export const partnerSupportsFlatRate = pricingInfo => {
    return !!pricingInfo;
};
